export interface UserFeedbackEmojiType {
  imageSrc: string
  extensionSrc?: string
  expressionType: string
}

export const UserFeedbackEmoji: { [expressionType: string]: UserFeedbackEmojiType } = {
  defaultEmoji: {
    imageSrc: 'user-feedback/default-emoji.png',
    expressionType: 'placeHolder',
  },
  veryDissatisfied: {
    imageSrc: 'user-feedback/poorly-v1.png',
    expressionType: 'veryDissatisfied',
  },
  dissatisfied: {
    imageSrc: 'user-feedback/aBitPoorly.png',
    expressionType: 'dissatisfied',
  },
  satisfied: {
    imageSrc: 'user-feedback/happy.png',
    expressionType: 'satisfied',
  },
  verySatisfied: {
    imageSrc: 'user-feedback/fantastic.png',
    expressionType: 'verySatisfied',
  },
}

export const FeedbackProducts = {
  learningPath: 'learningPath',
  checklist: 'checklist',
  vcc: {
    activity: 'vcc#activity',
    video: 'vcc#video',
  },
  curriculum: {
    activity: 'curriculum#activity',
    video: 'curriculum#video',
  },
}
